import { useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import moment from "moment";
// Constants
import { WEB_SERVICE_MIMS } from "../../../../config/constants";
// Components
import { Container, NewPrescriptionButton, NewPrescriptionText, NewPrescriptionImgContainer, NewPrescriptionImg } from "./styles";
import Axios from "../../../../config/axios";
import Popup from "../../../popup";
import PrescriptionCanvas from "../prescriptionCanvas";
// Assets
import CrossImg from "../../../../assets/icons/ico_cross.svg";

const NewPrescription = ({
  prescribedDate,
  dateToPrescribe,
  setDateToPrescribe,
  prescribedProtocols,
  protocolsToPrescribe,
  setProtocolsToPrescribe,
  diagnosisObservation,
  diagnosisObservationToAdd,
  setDiagnosisObservationToAdd,
  setIsLoadingPrescriptions,
  rechargePrescriptions,
  setRechargePrescriptions,
}) => {
  const [isShowingNewPrescriptionForm, setIsShowingNewPrescriptionForm] = useState(false);
  const { patientId, software } = useParams();
  const [t] = useTranslation("global");

  const savePrescription = (e) => {
    e.preventDefault();
    const today = moment().startOf("day").format("YYYY-MM-DD");
    const dateToCompare = moment(dateToPrescribe, "YYYY-MM-DD");
    if (dateToCompare.isBefore(today)) return toast.error(t("diagnosisProtocols_alerts_selectCorrectDate"));
    if (!protocolsToPrescribe.length) return toast.error(t("diagnosisProtocols_alerts_addAtLeastOneSession"));

    const prescriptionsData = {
      prescriptions: protocolsToPrescribe,
      diagnosisObservation: diagnosisObservationToAdd,
    };

    Axios("post", `${WEB_SERVICE_MIMS}/prescriptions/diagnosis/add/${patientId}/${software}`, prescriptionsData)
      .then(({ data }) => {
        if (data.success) {
          toast.success(t("diagnosisProtocols_alerts_sessionCreated"));
          setIsLoadingPrescriptions(true);
          setRechargePrescriptions(!rechargePrescriptions);
        } else {
          toast.error(t("sendDataErrorMessage"));
        }
      })
      .catch((error) => {
        toast.error(t("sendDataErrorMessage"));
        console.log("Add diagnosis prescription: ", error);
      });
  };

  const renderNewPrescriptionButton = () => {
    const showingNewMessageForm = () => {
      if (prescribedProtocols.length) return toast.error(t("diagnosisProtocols_alerts_activeSession"));
      setIsShowingNewPrescriptionForm(true);
    };

    return (
      <Container>
        <NewPrescriptionButton onClick={showingNewMessageForm}>
          <NewPrescriptionText>{t("diagnosisProtocols_titles_addDiagnosisSession")}</NewPrescriptionText>
          <NewPrescriptionImgContainer>
            <NewPrescriptionImg src={CrossImg} alt="ico-new-prescription" />
          </NewPrescriptionImgContainer>
        </NewPrescriptionButton>
      </Container>
    );
  };

  const renderPrescriptionPopup = () => {
    return (
      <Popup isShowed={isShowingNewPrescriptionForm} setIsShowed={setIsShowingNewPrescriptionForm}>
        <PrescriptionCanvas
          title={t("diagnosisProtocols_titles_addDiagnosisSession")}
          isOnlyDisplayed={true}
          prescribedDate={prescribedDate}
          dateToPrescribe={dateToPrescribe}
          setDateToPrescribe={setDateToPrescribe}
          prescribedProtocols={prescribedProtocols}
          protocolsToPrescribe={protocolsToPrescribe}
          setProtocolsToPrescribe={setProtocolsToPrescribe}
          diagnosisObservation={diagnosisObservation}
          diagnosisObservationToAdd={diagnosisObservationToAdd}
          setDiagnosisObservationToAdd={setDiagnosisObservationToAdd}
          setIsShowingPrescriptionForm={setIsShowingNewPrescriptionForm}
          rechargePrescriptions={rechargePrescriptions}
          setRechargePrescriptions={setRechargePrescriptions}
          savePrescription={savePrescription}
        />
      </Popup>
    );
  };

  return (
    <>
      {renderNewPrescriptionButton()}
      {renderPrescriptionPopup()}
    </>
  );
};

export default NewPrescription;
